import { SVGProps } from 'react';
export const Vector1 = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={2} height={11} fill="none" {...props} data-sentry-element="svg" data-sentry-component="Vector1" data-sentry-source-file="Vector1.tsx">
    <path stroke="#BEC3CC" d="M1 .25v10.5" data-sentry-element="path" data-sentry-source-file="Vector1.tsx" />
  </svg>;